import Layout from "layouts/Layout";
import Auth from "modules/Auth/Middleware/Auth";
import MembershipSummaryContent from "modules/MembershipSummary";

import React from "react";

import { setTitle } from "utilities/helper/setTitle";

const MembershipSummaryPage: React.FC = () => {
  setTitle("Membership Summary");
  return (
    <Auth>
      <Layout>
       <MembershipSummaryContent />
      </Layout>
    </Auth>
  );
};

export default MembershipSummaryPage;
